import { render, staticRenderFns } from "./addmould.vue?vue&type=template&id=20b13ab6&scoped=true&"
import script from "./addmould.vue?vue&type=script&lang=js&"
export * from "./addmould.vue?vue&type=script&lang=js&"
import style0 from "./addmould.vue?vue&type=style&index=0&id=20b13ab6&scoped=true&lang=css&"
import style1 from "./addmould.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b13ab6",
  null
  
)

export default component.exports